import {
  ensure,
  wrapErrors,
  asAInteger,
  beAtLeast,
  notEmpty,
} from "../Common/composition";

const expressAsKbps = (value) => Math.floor(value * 1000).toString();

export const formatValue = ( precision=0, thousands=true) => value =>
  Number(value).toLocaleString(undefined,  {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
    useGrouping: thousands,
  });

const noDecimalsWithThousands = formatValue(0/*precision*/, /*thousans*/true);

const validateThreshold = wrapErrors(
  (error) => `threshold value ${error}`,
  ensure(notEmpty, asAInteger(beAtLeast(0), expressAsKbps))
);

const thresholdComposition = {
  cliType: "throughput",
  typeLabel: "Throughput",
  viewURL: "viewThroughputProfileConfig",
  fields: [
    { name: "name", label: "Profile name", type: "text", canUpdate: true },
    {
      name: "threshold",
      label: "Threshold (Mbps)",
      type: "number",
      icon: "label_outline",
      renderValue: noDecimalsWithThousands,
      validate: validateThreshold,
    },
  ],
};

export default thresholdComposition;
